import { DialogMaster } from "#core/components/dialog/Dialog"
import InputFilePDF from "#core/components/input/file/InputFilePDF"
import { useApiSend } from "#hooks/useApiSend"
import { evaluationActionPlanIdPut } from "#performance-evaluation/services/api"
import DescriptionIcon from "@mui/icons-material/Description"
import { Box, Typography } from "@mui/material"
import { useReloadRefresh } from "app/reload"
import { useState } from "react"

export default function ActionPlanEvidence({ open = true, setOpen, actionPlan }) {
	const { refresh } = useReloadRefresh()
	const [file, setFile] = useState(null)
	const [disabled, setDisabled] = useState(false)
	const success = () => {
		refresh()
		setOpen(false)
	}
	const end = () => {
		setDisabled(false)
	}
	const { fetch } = useApiSend(evaluationActionPlanIdPut, { success, end })
	const handleSubmit = () => {
		const data = new FormData()
		data.append("url_s3", file)
		setDisabled(true)
		fetch(actionPlan.id, data)
	}

	return (
		<DialogMaster
			{...{
				open,
				setOpen,
				maxWidth: "sm",
				handleSubmit,
				title: "Agregar Evidencia",
				disabled,
			}}
		>
			<Box p={2} display="flex" flexDirection="column" gap={3}>
				<Box>
					<Typography variant="body1" gutterBottom>
						Plan de acción: <strong>{actionPlan.competencia_name}</strong>
					</Typography>
					<Typography variant="body2" color="text.secondary">
						Adjunta documentos que respalden el cumplimiento de este plan de acción.
					</Typography>
				</Box>
				<InputFilePDF
					icon={<DescriptionIcon />}
					label="Seleccionar archivo PDF"
					value={file}
					setValue={setFile}
				/>
			</Box>
		</DialogMaster>
	)
}
